import { EndpointBuilder } from '@reduxjs/toolkit/query/react';
import { ApiBaseQuery, ApiTagTypes } from '../types';
import {
    PatchRegCustomer,
    RegCustomer,
    SendRegistrationEmailRequest,
    UploadRegCustomerFileResponse,
    VerifyRegistrationEmailRequest,
} from './types';

/**
 * Endpoints для регистрации (публичные)
 */
export const registrationEndpoints = (builder: EndpointBuilder<ApiBaseQuery, ApiTagTypes, 'api'>) => ({
    /**
     * Отправка email для регистрации (отправка кода на почту)
     * POST /public/customer/email
     * 400 — невалидный email
     * 429 — превышен лимит запросов
     * 500 — ошибка сервера
     */
    sendRegistrationEmail: builder.mutation<void, SendRegistrationEmailRequest>({
        query: (body) => ({
            url: '/public/customer/email',
            method: 'POST',
            body,
        }),
    }),
    /**
     * Верификация кода из email
     * POST /public/customer/email/verify
     * 400 — невалидный email
     * 401 — неверный код
     * 429 — рейтлимит
     * 500 — ошибка сервера
     */
    verifyRegistrationEmail: builder.mutation<void, VerifyRegistrationEmailRequest>({
        query: (body) => ({
            url: '/public/customer/email/verify',
            method: 'POST',
            body,
        }),
    }),
    /**
     * Текущее состояние пользователя в процессе регистрации
     * GET /reg/customer
     */
    getRegCustomer: builder.query<RegCustomer, void>({
        query: () => ({
            url: '/reg/customer',
        }),
        providesTags: ['RegCustomer'],
    }),
    /**
     * Обновление данных регистрации (офис, тариф и т.д.)
     * PATCH /reg/customer
     */
    patchRegCustomer: builder.mutation<RegCustomer, PatchRegCustomer>({
        query: (body) => ({
            url: '/reg/customer',
            method: 'PATCH',
            body,
        }),
        invalidatesTags: ['RegCustomer'],
    }),
    /**
     * Загрузка файла клиента в процессе регистрации
     * POST /reg/customer/file
     * multipart/form-data: file
     */
    uploadRegCustomerFile: builder.mutation<UploadRegCustomerFileResponse, File>({
        query: (file) => {
            const formData = new FormData();
            formData.append('file', file);
            return {
                url: '/reg/customer/file',
                method: 'POST',
                body: formData,
            };
        },
        invalidatesTags: ['RegCustomer'],
    }),
    /**
     * Загрузка скана обратной стороны паспорта
     * POST /reg/customer/file_reverse
     * multipart/form-data: file
     */
    uploadRegCustomerReverseFile: builder.mutation<UploadRegCustomerFileResponse, File>({
        query: (file) => {
            const formData = new FormData();
            formData.append('file', file);
            return {
                url: '/reg/customer/file_reverse',
                method: 'POST',
                body: formData,
            };
        },
        invalidatesTags: ['RegCustomer'],
    }),
    /**
     * Подтверждение завершения регистрации
     * POST /reg/customer/complete
     * 200 — OK (без тела)
     * 400 — validation_failed + список невалидных полей
     */
    completeRegCustomer: builder.mutation<void, void>({
        query: () => ({
            url: '/reg/customer/complete',
            method: 'POST',
        }),
    }),
});
